import { createSelector } from 'reselect';
// Import enumerations.
import {

} from '@app/enumerations';
// Import state types.
import {
	PolicyState,
} from '@app/redux/states';
// Import api models.
import {
	PolicyNoteEmail,
} from '@app/models/api';
// Import base selectors.
import {
	getPoliciesState,
} from '@app/redux/selectors/base';

// Get Policy Note Emails Selector.
const makeGetPolicyNoteEmailsSelector = () => createSelector(
	[getPoliciesState],
	(policyState: PolicyState | undefined): PolicyNoteEmail[] => {
		return policyState !== undefined
			? policyState.policyNoteEmails
			: [];
	}
);

// Get Policy Note Emails Count Selector.
const makeGetPolicyNoteEmailsCountSelector = () => createSelector(
	[makeGetPolicyNoteEmailsSelector()],
	(policyNoteEmails: PolicyNoteEmail[]): number => {
		return policyNoteEmails.length;
	}
);

// Get Policy Note Email Ids Selector.
const makeGetPolicyNoteEmailIdsSelector = () => createSelector(
	[makeGetPolicyNoteEmailsSelector()],
	(policyNoteEmails: PolicyNoteEmail[]): number[] => {
		return policyNoteEmails.map((policyNoteEmail: PolicyNoteEmail) => {
			return policyNoteEmail.id !== null ? policyNoteEmail.id : -1;
		}).filter((policyNoteEmailId: number) => {
			return policyNoteEmailId !== -1;
		});
	}
);

// Are Policy Note Emails Loaded Selector.
const makeArePolicyNoteEmailsLoadedSelector = () => createSelector(
	[getPoliciesState],
	(policyState: PolicyState | undefined): boolean => {
		return policyState !== undefined
			? policyState.arePolicyNoteEmailsLoaded
			: false;
	}
);

// export selectors.
export {
	makeGetPolicyNoteEmailsSelector,
	makeGetPolicyNoteEmailsCountSelector,
	makeGetPolicyNoteEmailIdsSelector,
	makeArePolicyNoteEmailsLoadedSelector,
};